export default __webpack_public_path__ + "static/media/23.e96ffe88.png";